export default __webpack_public_path__ + "static/media/The Infernus of Dagon.267db51d.jpg";